<mwe-basic-card [hasBackground]="true" class="d-block mb-4">
  @if (isTitleVisible) {
    <mwe-basic-card-title [cardTitle]="sepaTitle" iconClass="fas fa-wallet" headingNodeType="h2" />
  }

  @if (isSepaOrZahlscheinSliderVisible) {
    @if (showPaymentSelectForm) {
      <mwe-form
        #paymentForm
        [formModel]="paymentSelectionForm"
        (formIsValid)="onPaymentFormChange($event)"
        (formIsInvalid)="onPaymentFormChange($event)"
      />
    }
    @if (!showPaymentSelectForm) {
      <p class="control-label mb-2 d-inline-block" [translate]="'invoiceInformation.paymentOptions.title'"></p>
    }
    @if (!showPaymentSelectForm) {
      <p class="text--big" translate="{{ toggleInvoiceLabel }}"></p>
    }
  }

  @if (invoiceSEPA) {
    <mwe-iban-form
      [config]="ibanConfig"
      (formSubmitted)="ibanFormSubmitted($event)"
      (validationErrors)="ibanFormError($event)"
      [productCategories]="productCategories"
    />
  }
</mwe-basic-card>

@if (isInternationalAddressInputVisible) {
  <mwe-basic-card
    [hasBackground]="true"
    [cardTitle]="newInvoiceAddressTitle"
    headingNodeType="h2"
    iconClass="fas fa-home"
    class="d-block mb-4"
  >
    <div class="pb-2" data-test="invoice-information-international-address-selection">
      <mwe-international-address-input
        [initialOlavEntry]="invoiceInfoConfig.initialAddressData?.olavEntry"
        [initialDataForManualForm]="invoiceInfoConfig.initialAddressData?.address"
        (selectionFinishedEvent)="checkAddress()"
      />
    </div>
  </mwe-basic-card>
}

@if (isERechnungVisible) {
  <mwe-basic-card
    [hasBackground]="true"
    [cardTitle]="eRechnungTitle"
    headingNodeType="h2"
    iconClass="fas fa-envelope-open-text"
    class="d-block mb-4"
  >
    <div class="row pb-3">
      @if (!showInvoiceSelectForm) {
        <p class="control-label mb-2 d-inline-block" translate="invoiceInformation.invoiceOptions.title"></p>
      }
      @if (showInvoiceSelectForm) {
        <div>
          <mwe-form
            #invoiceForm
            [formModel]="invoiceSelectionForm"
            (formIsValid)="onInvoiceFormChange($event)"
            (formIsInvalid)="onInvoiceFormChange($event)"
          />
        </div>
      }
      @if (!showInvoiceSelectForm) {
        <p class="text--big mb-0 pt-0 pb-2" translate="{{ toggleERechnungLabel }}"></p>
      }
      @if (erechnungEnabled) {
        <div data-test="invoice-information-eBilling-text">
          <mwe-form
            #emailForm
            [formModel]="emailAddressForm"
            (formIsValid)="onEmailFormChange($event, true)"
            (formIsInValid)="onEmailFormChange($event, false)"
          />
        </div>
      }
      @if (!erechnungEnabled && address) {
        <div data-test="invoice-information-eBilling-text">
          <mwe-form #emailForm [formModel]="readonlyAddressForm" />
        </div>
      }
    </div>
    @if (invoiceInfoConfig.customerDataChangeEmailMsgKey && erechnungEnabled) {
      <mwe-infobox
        [messageKey]="invoiceInfoConfig.customerDataChangeEmailMsgKey"
        [textParams]="{ email: overrideEmailAddress ?? erechnungData?.rechnungEmail, address: address }"
        class="d-block mb-3"
      />
    }
    @if (showInvoiceAddressChangeWarning) {
      <mwe-infobox type="warning" [messageKey]="eRechnungAddressChangeKey" [textParams]="addressChangeWarningPlaceholders" />
    }
  </mwe-basic-card>
}
